import { createContext } from 'react';

const AuthHeaderContext = createContext<(_: boolean) => void>(() => {});

export default AuthHeaderContext;
